enum IncomeTypeEnum {
    EMPLOYEE = "EMPLOYEE",
    ENTREPRENEUR = "ENTREPRENEUR",
    MATERNITY_LEAVE = "MATERNITY_LEAVE",
    PENSIONER = "PENSIONER",
    STUDENT = "STUDENT",
    UNEMPLOYED = "UNEMPLOYED",
    FREELANCE_PROFESSIONS = "FREELANCE_PROFESSIONS",
    ANNUITY = "ANNUITY",
    OTHER = "OTHER",
}

export default IncomeTypeEnum;
